import { CreditRequestStates } from "./enums/creditRequestStates";

export class CreditRequestData {

  // Сумма кредита
  public Summa?: string;

  // Срок кредита
  public Period?: string;

  // Ставка кредита
  public PercentRate?: string;

  // Статус кредита
  public RequestState?: CreditRequestStates;

  // Платёж по кредиту
  public Payment?: string;

  // Код операции отмены заявка
  public CancelCatId?: string;

  // Код операции оформления заявка
  public AcceptCatId?: string;

  // Тип кредита
  public CreditType?: string;

  // Описание
  public Rem?: string;

  constructor(customFieldsXml: string) {
    const parser = new DOMParser();
    const xDoc = parser.parseFromString(customFieldsXml, "text/xml");
    const xmlFields = xDoc.getElementsByTagName('Field');

    for (let i = 0; i < xmlFields.length; i++) {
      const field = xmlFields[i];
      const key = field.getAttribute('name');
      const value = field.getAttribute('value');
      if (key && value !== null) {
        this.setFieldValue(key, value);
      }
    }
  }
    
  private setFieldValue(key: string, value: string): void {
    switch (key) {
      case 'Summa':
        this.Summa = value;
        break;
      case 'Period':
        this.Period = value;
        break;
      case 'PercentRate':
        this.PercentRate = value;
        break;
      case 'RequestStatus':
        const numericValue = parseInt(value, 10);
        if (isNaN(numericValue)) {
          this.RequestState = CreditRequestStates.UnderConsideration;
        } else {
          this.RequestState = numericValue as CreditRequestStates;
        }
        break;
      case 'Payment':
        this.Payment = value;
        break;
      case 'CancelCatId':
        this.CancelCatId = value;
        break;
      case 'AcceptCatId':
        this.AcceptCatId = value;
        break;
      case 'CreditType':
        this.CreditType = value;
        break;
      case 'Rem':
        this.Rem = value;
        break;
    }
  }
}